module.exports = __webpack_public_path__ + "static/media/spoofing.cc439731.png";